import React from 'react'
import { connect } from 'react-redux'
import { InfoAlert, WarningAlert } from 'pivotal-ui/react/alerts'
import { Dispatch } from 'redux'
import {
  dismissSharedLinkRestoreBanner,
  SharedLinkRestoreStatus,
  SharedLinkRestoreStatusAction
} from '../actions/shared_link_restore_status'
import { UpgradePortalStore } from '../stores/store'

type SharedLinkRestoreBannerProps = {
  sharedLinkRestoreStatus: SharedLinkRestoreStatus
  dismissSharedLinkRestoreBanner: () => SharedLinkRestoreStatusAction
}

export const SharedLinkRestoreBanner = (
  {
    sharedLinkRestoreStatus,
    dismissSharedLinkRestoreBanner
  }: SharedLinkRestoreBannerProps) => {

  if (sharedLinkRestoreStatus === SharedLinkRestoreStatus.RESTORE_FAILED) {
    return (
      <div id={'shared-link-restore-banner'}>
        <WarningAlert withIcon dismissable onDismiss={dismissSharedLinkRestoreBanner}>
          This shared link could not be read, so no products were restored from it. Please request
          an updated link from the sender, or add your products below.
        </WarningAlert>
      </div>
    )
  }

  if (sharedLinkRestoreStatus === SharedLinkRestoreStatus.NEEDS_REVIEW) {
    return (
      <div id={'shared-link-restore-banner'}>
        <InfoAlert withIcon dismissable onDismiss={dismissSharedLinkRestoreBanner}>
          Products and versions were restored from this shared link. The plan was not generated
          automatically because one or more versions require review. Please correct the versions
          highlighted below, then select Generate Plan.
        </InfoAlert>
      </div>
    )
  }

  return null
}

const mapStateToProps = ({sharedLinkRestoreStatus}: UpgradePortalStore) => {
  return {sharedLinkRestoreStatus}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dismissSharedLinkRestoreBanner: () => dispatch(dismissSharedLinkRestoreBanner())
})

export default connect(mapStateToProps, mapDispatchToProps)(SharedLinkRestoreBanner)
